/*
 * US ZIP code to state lookup for the cart drawer shipping calculator.
 *
 * /cart/shipping_rates.json will not return rates from a ZIP alone. It needs
 * country and, for the United States, province. This table resolves the state
 * from the ZIP so the customer only ever types a ZIP code.
 *
 * Data: US Postal Service ZIP database (python `zipcodes` package, active
 * records only), reduced to 3 digit prefixes. 925 of the 933 prefixes map to
 * exactly one state. The 8 that straddle a state line (063, 099, 205, 726,
 * 739, 834, 967, 969) are resolved from the full 5 digit ZIP instead.
 *
 * Format: ZIP3 is a flat string of 5 character records, NNNSS.
 *         ZIP5 is a flat string of 7 character records, NNNNNSS.
 *         Both are sorted, and parsed into lookup objects once on first use.
 */
window.LobsterBoysZipState = (function () {
  'use strict';

  var ZIP3 =
    '005NY006PR007PR008VI009PR010MA011MA012MA013MA014MA015MA016MA017MA018MA019MA020MA021MA022MA023MA024MA' +
    '025MA026MA027MA028RI029RI030NH031NH032NH033NH034NH035NH036NH037NH038NH039ME040ME041ME042ME043ME044ME' +
    '045ME046ME047ME048ME049ME050VT051VT052VT053VT054VT055MA056VT057VT058VT059VT060CT061CT062CT064CT065CT' +
    '066CT067CT068CT069CT070NJ071NJ072NJ073NJ074NJ075NJ076NJ077NJ078NJ079NJ080NJ081NJ082NJ083NJ084NJ085NJ' +
    '086NJ087NJ088NJ089NJ090AE091AE092AE093AE094AE095AE096AE097AE098AE100NY101NY102NY103NY104NY105NY106NY' +
    '107NY108NY109NY110NY111NY112NY113NY114NY115NY116NY117NY118NY119NY120NY121NY122NY123NY124NY125NY126NY' +
    '127NY128NY129NY130NY131NY132NY133NY134NY135NY136NY137NY138NY139NY140NY141NY142NY143NY144NY145NY146NY' +
    '147NY148NY149NY150PA151PA152PA153PA154PA155PA156PA157PA158PA159PA160PA161PA162PA163PA164PA165PA166PA' +
    '167PA168PA169PA170PA171PA172PA173PA174PA175PA176PA177PA178PA179PA180PA181PA182PA183PA184PA185PA186PA' +
    '187PA188PA189PA190PA191PA192PA193PA194PA195PA196PA197DE198DE199DE200DC201VA202DC203DC204DC206MD207MD' +
    '208MD209MD210MD211MD212MD214MD215MD216MD217MD218MD219MD220VA221VA222VA223VA224VA225VA226VA227VA228VA' +
    '229VA230VA231VA232VA233VA234VA235VA236VA237VA238VA239VA240VA241VA242VA243VA244VA245VA246VA247WV248WV' +
    '249WV250WV251WV252WV253WV254WV255WV256WV257WV258WV259WV260WV261WV262WV263WV264WV265WV266WV267WV268WV' +
    '270NC271NC272NC273NC274NC275NC276NC277NC278NC279NC280NC281NC282NC283NC284NC285NC286NC287NC288NC289NC' +
    '290SC291SC292SC293SC294SC295SC296SC297SC298SC299SC300GA301GA302GA303GA304GA305GA306GA307GA308GA309GA' +
    '310GA311GA312GA313GA314GA315GA316GA317GA318GA319GA320FL321FL322FL323FL324FL325FL326FL327FL328FL329FL' +
    '330FL331FL332FL333FL334FL335FL336FL337FL338FL339FL340AA341FL342FL344FL346FL347FL349FL350AL351AL352AL' +
    '354AL355AL356AL357AL358AL359AL360AL361AL362AL363AL364AL365AL366AL367AL368AL369AL370TN371TN372TN373TN' +
    '374TN375TN376TN377TN378TN379TN380TN381TN382TN383TN384TN385TN386MS387MS388MS389MS390MS391MS392MS393MS' +
    '394MS395MS396MS397MS398GA399GA400KY401KY402KY403KY404KY405KY406KY407KY408KY409KY410KY411KY412KY413KY' +
    '414KY415KY416KY417KY418KY420KY421KY422KY423KY424KY425KY426KY427KY430OH431OH432OH433OH434OH435OH436OH' +
    '437OH438OH439OH440OH441OH442OH443OH444OH445OH446OH447OH448OH449OH450OH451OH452OH453OH454OH455OH456OH' +
    '457OH458OH459OH460IN461IN462IN463IN464IN465IN466IN467IN468IN469IN470IN471IN472IN473IN474IN475IN476IN' +
    '477IN478IN479IN480MI481MI482MI483MI484MI485MI486MI487MI488MI489MI490MI491MI492MI493MI494MI495MI496MI' +
    '497MI498MI499MI500IA501IA502IA503IA504IA505IA506IA507IA508IA509IA510IA511IA512IA513IA514IA515IA516IA' +
    '520IA521IA522IA523IA524IA525IA526IA527IA528IA530WI531WI532WI534WI535WI537WI538WI539WI540WI541WI542WI' +
    '543WI544WI545WI546WI547WI548WI549WI550MN551MN553MN554MN555MN556MN557MN558MN559MN560MN561MN562MN563MN' +
    '564MN565MN566MN567MN569DC570SD571SD572SD573SD574SD575SD576SD577SD580ND581ND582ND583ND584ND585ND586ND' +
    '587ND588ND590MT591MT592MT593MT594MT595MT596MT597MT598MT599MT600IL601IL602IL603IL604IL605IL606IL607IL' +
    '608IL609IL610IL611IL612IL613IL614IL615IL616IL617IL618IL619IL620IL622IL623IL624IL625IL626IL627IL628IL' +
    '629IL630MO631MO633MO634MO635MO636MO637MO638MO639MO640MO641MO644MO645MO646MO647MO648MO649MO650MO651MO' +
    '652MO653MO654MO655MO656MO657MO658MO660KS661KS662KS664KS665KS666KS667KS668KS669KS670KS671KS672KS673KS' +
    '674KS675KS676KS677KS678KS679KS680NE681NE683NE684NE685NE686NE687NE688NE689NE690NE691NE692NE693NE700LA' +
    '701LA703LA704LA705LA706LA707LA708LA710LA711LA712LA713LA714LA716AR717AR718AR719AR720AR721AR722AR723AR' +
    '724AR725AR727AR728AR729AR730OK731OK733TX734OK735OK736OK737OK738OK740OK741OK743OK744OK745OK746OK747OK' +
    '748OK749OK750TX751TX752TX753TX754TX755TX756TX757TX758TX759TX760TX761TX762TX763TX764TX765TX766TX767TX' +
    '768TX769TX770TX772TX773TX774TX775TX776TX777TX778TX779TX780TX781TX782TX783TX784TX785TX786TX787TX788TX' +
    '789TX790TX791TX792TX793TX794TX795TX796TX797TX798TX799TX800CO801CO802CO803CO804CO805CO806CO807CO808CO' +
    '809CO810CO811CO812CO813CO814CO815CO816CO820WY821WY822WY823WY824WY825WY826WY827WY828WY829WY830WY831WY' +
    '832ID833ID835ID836ID837ID838ID840UT841UT842UT843UT844UT845UT846UT847UT850AZ851AZ852AZ853AZ855AZ856AZ' +
    '857AZ859AZ860AZ863AZ864AZ865AZ870NM871NM873NM874NM875NM876NM877NM878NM879NM880NM881NM882NM883NM884NM' +
    '885TX888DC889NV890NV891NV893NV894NV895NV897NV898NV900CA901CA902CA903CA904CA905CA906CA907CA908CA910CA' +
    '911CA912CA913CA914CA915CA916CA917CA918CA919CA920CA921CA922CA923CA924CA925CA926CA927CA928CA930CA931CA' +
    '932CA933CA934CA935CA936CA937CA938CA939CA940CA941CA942CA943CA944CA945CA946CA947CA948CA949CA950CA951CA' +
    '952CA953CA954CA955CA956CA957CA958CA959CA960CA961CA962AP963AP964AP965AP966AP968HI970OR971OR972OR973OR' +
    '974OR975OR976OR977OR978OR979OR980WA981WA982WA983WA984WA985WA986WA988WA989WA990WA991WA992WA993WA994WA' +
    '995AK996AK997AK998AK999AK';

  var ZIP5 =
    '06320CT06330CT06331CT06332CT06333CT06334CT06335CT06336CT06338CT06339CT06340CT06349CT06350CT06351CT06' +
    '353CT06354CT06355CT06357CT06359CT06360CT06365CT06370CT06371CT06372CT06373CT06374CT06375CT06376CT0637' +
    '7CT06378CT06379CT06380CT06382CT06383CT06384CT06385CT06387CT06388CT06389CT06390NY09901AE09902AE09903A' +
    'E09904AE09905NJ09908AE09909AE09910AE09974AE09975AE09976AE09977AE09978AE09980NJ09981NJ09982NJ09983NJ0' +
    '9984NJ20500DC20501DC20502DC20503DC20504DC20505DC20506DC20507DC20508DC20509DC20510DC20511DC20515DC205' +
    '20DC20521DC20522DC20523DC20524DC20525DC20526DC20527DC20528DC20529DC20530DC20531DC20533DC20534DC20535' +
    'DC20536DC20537DC20538DC20539DC20540DC20541DC20542DC20543DC20544DC20546DC20547DC20548DC20549DC20551DC' +
    '20552DC20553DC20554DC20555DC20557DC20559DC20560DC20565DC20566DC20570DC20571DC20572DC20573DC20575DC20' +
    '576DC20577DC20578DC20579DC20580DC20581DC20585DC20586DC20588MD20590DC20591DC20593DC20594DC20597DC2059' +
    '8VA20599DC72601AR72602AR72611AR72613AR72615AR72616AR72617AR72619AR72623AR72624AR72626AR72628AR72629A' +
    'R72630AR72631AR72632AR72633AR72634AR72635AR72636AR72638AR72639AR72640AR72641AR72642AR72643MO72644AR7' +
    '2645AR72648AR72650AR72651AR72653AR72654AR72655AR72657AR72658AR72659AR72660AR72661AR72662AR72663AR726' +
    '66AR72668AR72669AR72670AR72672AR72675AR72677AR72679AR72680AR72682AR72683AR72685AR72686AR72687AR73901' +
    'OK73931OK73932OK73933OK73937OK73938OK73939OK73942OK73944OK73945OK73946OK73947OK73949OK73950OK73951OK' +
    '73960TX83401ID83402ID83403ID83404ID83405ID83406ID83414WY83415ID83420ID83421ID83422ID83423ID83424ID83' +
    '425ID83427ID83428ID83429ID83431ID83433ID83434ID83435ID83436ID83438ID83440ID83441ID83442ID83443ID8344' +
    '4ID83445ID83446ID83448ID83449ID83450ID83451ID83452ID83454ID83455ID83460ID83462ID83463ID83464ID83465I' +
    'D83466ID83467ID83468ID83469ID96701HI96703HI96704HI96705HI96706HI96707HI96708HI96709HI96710HI96712HI9' +
    '6713HI96714HI96715HI96716HI96717HI96718HI96719HI96720HI96721HI96722HI96725HI96726HI96727HI96728HI967' +
    '29HI96730HI96731HI96732HI96733HI96734HI96737HI96738HI96739HI96740HI96741HI96742HI96743HI96744HI96745' +
    'HI96746HI96747HI96748HI96749HI96750HI96751HI96752HI96753HI96754HI96755HI96756HI96757HI96759HI96760HI' +
    '96761HI96762HI96763HI96764HI96765HI96766HI96767HI96768HI96769HI96770HI96771HI96772HI96773HI96774HI96' +
    '776HI96777HI96778HI96779HI96780HI96781HI96782HI96783HI96784HI96785HI96786HI96788HI96789HI96790HI9679' +
    '1HI96792HI96793HI96795HI96796HI96797HI96799AS96910GU96912GU96913GU96915GU96916GU96917GU96919GU96921G' +
    'U96923GU96928GU96929GU96931GU96932GU96939PW96940PW96941FM96942FM96943FM96944FM96950MP96951MP96952MP9' +
    '6960MH96970MH';

  var ZIP3_AMBIGUOUS_FALLBACK =
    '063CT099AE205DC726AR739OK834ID967HI969GU';

  var STATE_NAMES = {
    AA: 'Armed Forces Americas', AE: 'Armed Forces Europe', AK: 'Alaska',
    AL: 'Alabama', AP: 'Armed Forces Pacific', AR: 'Arkansas',
    AS: 'American Samoa', AZ: 'Arizona', CA: 'California',
    CO: 'Colorado', CT: 'Connecticut', DC: 'District of Columbia',
    DE: 'Delaware', FL: 'Florida', FM: 'Federated States of Micronesia',
    GA: 'Georgia', GU: 'Guam', HI: 'Hawaii',
    IA: 'Iowa', ID: 'Idaho', IL: 'Illinois',
    IN: 'Indiana', KS: 'Kansas', KY: 'Kentucky',
    LA: 'Louisiana', MA: 'Massachusetts', MD: 'Maryland',
    ME: 'Maine', MH: 'Marshall Islands', MI: 'Michigan',
    MN: 'Minnesota', MO: 'Missouri', MP: 'Northern Mariana Islands',
    MS: 'Mississippi', MT: 'Montana', NC: 'North Carolina',
    ND: 'North Dakota', NE: 'Nebraska', NH: 'New Hampshire',
    NJ: 'New Jersey', NM: 'New Mexico', NV: 'Nevada',
    NY: 'New York', OH: 'Ohio', OK: 'Oklahoma',
    OR: 'Oregon', PA: 'Pennsylvania', PR: 'Puerto Rico',
    PW: 'Palau', RI: 'Rhode Island', SC: 'South Carolina',
    SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas',
    UT: 'Utah', VA: 'Virginia', VI: 'Virgin Islands',
    VT: 'Vermont', WA: 'Washington', WI: 'Wisconsin',
    WV: 'West Virginia', WY: 'Wyoming',
  };

  var map3 = null;
  var map5 = null;
  var mapFallback = null;

  function unpack(source, keyLength) {
    var recordLength = keyLength + 2;
    var result = {};
    var index;

    for (index = 0; index + recordLength <= source.length; index += recordLength) {
      result[source.substr(index, keyLength)] = source.substr(index + keyLength, 2);
    }

    return result;
  }

  function ensureLoaded() {
    if (map3) {
      return;
    }
    map3 = unpack(ZIP3, 3);
    map5 = unpack(ZIP5, 5);
    mapFallback = unpack(ZIP3_AMBIGUOUS_FALLBACK, 3);
  }

  /* Returns a two letter state code, or an empty string when the ZIP is unknown. */
  function stateCode(zip) {
    var digits = String(zip || '').replace(/[^0-9]/g, '');
    var prefix;

    if (digits.length < 5) {
      return '';
    }

    ensureLoaded();
    digits = digits.slice(0, 5);
    prefix = digits.slice(0, 3);

    if (map3[prefix]) {
      return map3[prefix];
    }

    if (map5[digits]) {
      return map5[digits];
    }

    /* Known split prefix, unrecognised ZIP within it. */
    return mapFallback[prefix] || '';
  }

  function stateName(code) {
    return STATE_NAMES[code] || '';
  }

  return { stateCode: stateCode, stateName: stateName };
}());
